module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lf"
  }, [_c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "label": "Sucursales",
      "bottom": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "item-text": "name",
      "label": "Edificios",
      "item-value": "id",
      "bottom": "",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.settings.showTypes) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.types,
      "hide-details": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-switch": false,
      "include-settings": false,
      "go-to-settings-page": "/",
      "selectable": false,
      "include-search": false,
      "include-delete-single": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', {
          on: {
            "click": function($event) {
              _vm.rowSelected(props.row)
            }
          }
        }, [_vm._v(_vm._s(props.row[_vm.typeSelected.columnName]))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('lost-found-item', {
      key: item.id,
      attrs: {
        "is-loading": item.isLoading,
        "images": item.images,
        "comment": item.comment,
        "id": item.id,
        "status": item.status
      },
      on: {
        "status-change": _vm.updateStatus
      }
    }, [_vm._t("default", [_c('lost-found-header', {
      attrs: {
        "avatar": item.avatar,
        "date": item.date,
        "time": item.time,
        "author": item.name,
        "mode": _vm.mode
      }
    })])], 2)
  }))], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e3d3ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ObjectView.vue
// module id = 1217
// module chunks = 41 42